<template>
  <div>
    <!-- <div v-if="isShowOverlay" @click="closeNav()" class="overlay"></div>
    <div
      id="tracking-panel"
      :class="{ 'auto-show': autoShow }"
      class="sidenav-history"
      :style="{ width: computedWidth }"
    >
      <div v-if="!autoShow" class="header-tracking-panel font-16">
        Theo dõi trạng thái đơn hàng
        <b>{{ order.order_code }}</b>
        <a v-if="!autoShow" class="closebtn" @click="closeNav()">×</a>
      </div>
      <div class="content">
        <div class="timeline">
          <article class="timeline-item">
            <div class="text-right">
              <div class="time-show first">
                <a href="#" class="btn btn-primary w-lg">{{ $t('js.bat_dau') }}</a>
              </div>
            </div>
          </article>
          <article class="timeline-item alt">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow-alt"></span>
                  <span class="timeline-icon bg-success"></span>
                  <h4 class="text-danger">{{ $t('js.tao_don') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_duoc_khoi_tao_thanh_cong') }}</p>
                  <p class="timeline-date text-muted">
                    <i class="fa fa-clock-o"></i>
                    {{ formatDate(order.order_date) }}
                  </p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow"></span>
                  <template v-if="orderTracking.ready">
                    <span class="timeline-icon bg-success"></span>
                  </template>
                  <template v-else>
                    <span class="timeline-icon bg-danger"></span>
                  </template>
                  <h4 class="text-danger">{{ $t('js.san_sang') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_san_sang_duoc_van_chuyen') }}</p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item alt">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow-alt"></span>
                  <template v-if="orderTracking.wait_delivery">
                    <span class="timeline-icon bg-success"></span>
                  </template>
                  <template v-else>
                    <span class="timeline-icon bg-danger"></span>
                  </template>
                  <h4 class="text-danger">{{ $t('js.cho_nhan_hang') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_dang_cho_xe_den_nhan_hang') }}</p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow"></span>
                  <template v-if="orderTracking.received">
                    <span class="timeline-icon bg-success"></span>
                  </template>
                  <template v-else>
                    <span class="timeline-icon bg-danger"></span>
                  </template>
                  <h4 class="text-danger">{{ $t('js.nhan_hang') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_da_duoc_nhan_hang') }}</p>
                  <p class="timeline-date text-muted">
                    <i class="fa fa-clock-o"></i>
                    {{ formatDateTime(order.ETD_date + " " + order.ETD_time) }}
                  </p>
                  <p>
                    <i class="fa fa-map-marker"></i>
                    {{ order.location_destination }}
                  </p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item alt">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow-alt"></span>
                  <template v-if="orderTracking.shipped">
                    <span class="timeline-icon bg-success"></span>
                  </template>
                  <template v-else>
                    <span class="timeline-icon bg-danger"></span>
                  </template>
                  <h4 class="text-danger">{{ $t('js.van_chuyen') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_dang_trong_qua_trinh_van_chuyen') }}</p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item">
            <div class="timeline-desk">
              <div class="panel">
                <div class="panel-body">
                  <span class="arrow"></span>
                  <template v-if="orderTracking.delivered">
                    <span class="timeline-icon bg-success"></span>
                  </template>
                  <template v-else>
                    <span class="timeline-icon bg-danger"></span>
                  </template>
                  <h4 class="text-danger">{{ $t('js.tra_hang') }}</h4>
                  <p>{{ $t('js.don_hang_cua_quy_khach_da_duoc_tra_hang') }}</p>
                  <p class="timeline-date text-muted">
                    <i class="fa fa-clock-o"></i>
                    {{ formatDateTime(order.ETA_date + " " + order.ETA_time) }}
                  </p>
                  <p>
                    <i class="fa fa-map-marker"></i>
                    {{ order.location_arrival }}
                  </p>
                </div>
              </div>
            </div>
          </article>
          <article class="timeline-item alt">
            <div class="text-right">
              <div class="time-show">
                <template v-if="orderTracking.canceled">
                  <a href="#" class="btn btn-danger w-lg">{{ $t('js.huy_34ca764c') }}</a>
                </template>
                <template v-else>
                  <a href="#" class="btn btn-success w-lg">{{ $t('js.hoan_thanh') }}</a>
                </template>
              </div>
            </div>
          </article>
        </div>

        <div ref="mapsContainer" class="maps-container">
          <div class="total-distance">Tổng số km: {{ totalDistance }} km</div>
          <div ref="maps" class="maps"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import mixins from "../../mixins";

export default {
  mixins: [mixins],
  data: function () {
    return {
      width: "0px",
      totalDistance: 0,
      // directionsService: new google.maps.DirectionsService(),
      // directionsRenderer: new google.maps.DirectionsRenderer(),
    };
  },
  props: {
    orderTracking: {
      type: Object,
    },
    order: {
      type: Object,
    },
    autoShow: {
      type: Boolean,
    },
  },
  computed: {
    computedWidth: function () {
      if (this.autoShow) {
        return "100%";
      }
      return this.width;
    },
    isShowOverlay: function () {
      return this.width !== "0px";
    },
  },
  mounted() {
    // const mapOptions = {
    //   zoom: 14,
    // };
    // const map = new google.maps.Map(this.$refs.maps, mapOptions);
    // this.directionsRenderer.setMap(map);
    // this.renderDirections(this.order);
  },
  methods: {
    closeNav: function () {
      this.width = "0px";
    },
    openNav: function (order) {
      if (window.outerWidth < this.mobileWidth) {
        this.width = "100%";
      } else {
        this.width = "70%";
      }

      this.renderDirections(order);
    },
    renderDirections(order) {
      if (
        order.location_des_lat &&
        order.location_des_long &&
        order.location_arr_lat &&
        order.location_arr_long
      ) {
        const selectedMode = "DRIVING";
        const origin = new google.maps.LatLng(
          order.location_des_lat,
          order.location_des_long
        );
        const destination = new google.maps.LatLng(
          order.location_arr_lat,
          order.location_arr_long
        );

        const request = {
          origin,
          destination,
          travelMode: google.maps.TravelMode[selectedMode],
        };
        this.directionsService.route(request, (response, status) => {
          if (status == "OK") {
            this.$refs.mapsContainer.hidden = false;
            if (
              response &&
              response.routes &&
              response.routes.length > 0 &&
              response.routes[0].legs
            ) {
              const legs = response.routes[0].legs;
              this.totalDistance = 0;
              for (var i = 0; i < legs.length; ++i) {
                this.totalDistance += legs[i].distance.value / 1000;
              }
            }
            this.directionsRenderer.setDirections(response);
          } else {
            this.$refs.mapsContainer.hidden = true;
          }
        });
      } else {
        this.$refs.mapsContainer.hidden = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
}
.sidenav-history {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #11509b;
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  font-size: 0.8em;
  .header-tracking-panel {
    position: sticky;
    top: 0;
    padding-left: 25px;
    color: #ffffff;
    font-size: 15px;
    height: 50px;
    padding-top: 14px;
    z-index: 2;
    background: #11509b;
  }
  .closebtn {
    position: absolute;
    top: 4px;
    right: 25px;
    font-size: 24px;
    cursor: pointer;
    font-weight: bolder;
    color: #ffffff;
    z-index: 2;
  }

  &.auto-show {
    position: relative;
    padding-top: 0;
  }
}

.content {
  background-color: #f5f5f5;
  padding: 10px 20px 10px 20px;

  .maps-container {
    .maps {
      height: 300px;
      margin-bottom: 70px;
    }

    .total-distance {
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.timeline-item.alt:after,
.timeline-item:before,
.timeline:before {
  content: "";
}

.timeline .time-show a {
  color: #fff;
}

.timeline {
  border-collapse: collapse;
  border-spacing: 0;
  display: table;
  position: relative;
  table-layout: fixed;
  width: 100%;
}

.timeline .time-show {
  margin-bottom: 30px;
  margin-right: -75px;
  margin-top: 30px;
  position: relative;
}

.timeline:before {
  background-color: #d8d9df;
  bottom: 30px;
  left: 50%;
  position: absolute;
  top: 30px;
  width: 1px;
  z-index: 0;
}

.timeline .timeline-icon {
  -webkit-border-radius: 50%;
  background: #d8d9df;
  border-radius: 50%;
  border: 1px solid #d8d9df;
  color: #fff;
  display: block;
  height: 20px;
  left: -54px;
  margin-top: -10px;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 20px;
}

.timeline .timeline-icon i {
  margin-top: 9px;
}

.timeline .time-icon:before {
  font-size: 16px;
  margin-top: 5px;
}

h3.timeline-title {
  color: #c8ccd7;
  font-size: 20px;
  font-weight: 400;
  margin: 0 0 5px;
  text-transform: uppercase;
}

.timeline-item .timeline-desk .arrow,
.timeline-item.alt .timeline-desk .arrow-alt {
  border-bottom: 8px solid transparent;
  border-top: 8px solid transparent;
  height: 0;
  margin-top: -10px;
  position: absolute;
  top: 50%;
}

.timeline-item {
  display: table-row;
}

.timeline-item:before {
  display: block;
  width: 50%;
}

.timeline-item .timeline-desk .arrow {
  border-right: 8px solid #fff !important;
  display: block;
  left: -7px;
  width: 0;
}

.timeline-item.alt:after {
  display: block;
  width: 50%;
}

.timeline-item.alt .timeline-desk .arrow-alt {
  border-left: 8px solid #fff !important;
  display: block;
  left: auto;
  right: -7px;
  width: 0;
}

.timeline-item.alt .timeline-desk .album {
  float: right;
  margin-top: 20px;
}

.timeline-item.alt .timeline-desk .album a {
  float: right;
  margin-left: 5px;
}

.timeline-item.alt .timeline-icon {
  left: auto;
  right: -56px;
}

.timeline-item.alt:before {
  display: none;
}

.timeline-item.alt .panel {
  margin-left: 0;
  margin-right: 45px;
}

.panel .panel-body p {
  margin-top: 10px !important;
}

.timeline-item.alt .panel .panel-body p + p {
  margin-top: 10px !important;
}

.timeline-item.alt .timeline-date,
.timeline-item.alt h4,
.timeline-item.alt p {
  text-align: left;
}

.timeline-desk {
  display: table-cell;
  vertical-align: top;
  width: 50%;
}

.timeline-desk h4 {
  font-size: 15px;
  margin: 0;
}

.timeline-desk .panel {
  background: #fff;
  display: block;
  margin-bottom: 5px;
  margin-left: 45px;
  position: relative;
  text-align: left;
  padding: 15px;
  border-radius: 5px;
}

.timeline-desk h5 span {
  color: #797979;
  display: block;
  font-size: 11px;
  margin-bottom: 4px;
}

.timeline-desk p {
  color: #999;
  font-size: 13px;
  margin-bottom: 0;
}

.timeline-desk .album {
  margin-top: 12px;
}

.timeline-desk .album a {
  float: left;
  margin-right: 5px;
}

.timeline-desk .album img {
  height: 36px;
  width: auto;
  border-radius: 3px;
}

.timeline-desk .notification {
  background: #fff;
  margin-top: 20px;
  padding: 8px;
}

.timeline-2 {
  border-left: 2px solid #039cfd;
  position: relative;
}

.time-item:after,
.timeline-2 .time-item:after {
  background-color: #fff;
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  bottom: 0;
  left: 0;
  top: 5px;
}

.timeline-2 .time-item:after {
  border-color: #039cfd;
  content: "";
  height: 10px;
  margin-left: -6px;
  position: absolute;
  width: 10px;
}

.time-item {
  border-color: #dee5e7;
  padding-bottom: 10px;
  position: relative;
}

.time-item:before {
  content: " ";
  display: table;
}

.time-item:after {
  border-color: #039cfd;
  content: "";
  height: 14px;
  margin-left: -8px;
  position: absolute;
  width: 14px;
}

.time-item-item:after {
  content: " ";
  display: table;
}

.w-lg {
  min-width: 140px;
}
</style>
